import React from "react"
import Icon from "../icon"
import type { IconName } from "../icon"
import { OldIconButtonBase } from "./old-icon-button-base"
import type { OldIconButtonBaseProps } from "./old-icon-button-base"

type OldIconButtonProps = {
  /** Icon name from the design system icon library */
  icon: IconName
} & Omit<OldIconButtonBaseProps, "children">

const OldIconButton = React.forwardRef<
  HTMLButtonElement | HTMLAnchorElement,
  OldIconButtonProps
>(({ icon, ...props }, ref) => {
  return (
    <OldIconButtonBase {...props} ref={ref}>
      <Icon name={icon} className="pointer-events-none" />
    </OldIconButtonBase>
  )
})

export { OldIconButton, OldIconButton as IconButton }
